import { CustomFieldType } from './custom-field-type.enum';
import { ItemType } from '../domain';
var CustomFieldBuilder = /** @class */ (function () {
    function CustomFieldBuilder() {
        this.customField = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            name: 'bob-bob-bob',
            displayName: 'Bob',
            data: {
                multilingualData: {
                    en: {
                        title: 'A Title',
                        translatedTitles: {},
                        placeHolder: 'A Placeholder',
                        description: 'A Description',
                        values: [],
                        disabled: false
                    }
                },
                deletedValues: {
                    en: []
                }
            },
            creationDate: Date.now(),
            lastUpdateDate: Date.now(),
            type: CustomFieldType.TEXT,
            itemType: ItemType.TICKET
        };
    }
    CustomFieldBuilder.prototype.withId = function (id) {
        this.customField.id = id;
        return this;
    };
    CustomFieldBuilder.prototype.withName = function (name) {
        this.customField.name = name;
        return this;
    };
    CustomFieldBuilder.prototype.withDisplayName = function (displayName) {
        this.customField.displayName = displayName;
        return this;
    };
    CustomFieldBuilder.prototype.withData = function (data) {
        this.customField.data = data;
        return this;
    };
    CustomFieldBuilder.prototype.withLocaleData = function (locale, data) {
        this.customField.data.multilingualData[locale] = data;
        return this;
    };
    CustomFieldBuilder.prototype.withCreationDate = function (creationDate) {
        this.customField.creationDate = creationDate;
        return this;
    };
    CustomFieldBuilder.prototype.withLastUpdateDate = function (lastUpdateDate) {
        this.customField.lastUpdateDate = lastUpdateDate;
        return this;
    };
    CustomFieldBuilder.prototype.withType = function (type) {
        this.customField.type = type;
        return this;
    };
    CustomFieldBuilder.prototype.withItemType = function (itemType) {
        this.customField.itemType = itemType;
        return this;
    };
    CustomFieldBuilder.prototype.withValues = function (values) {
        this.customField.data.multilingualData.en.values = values;
        return this;
    };
    CustomFieldBuilder.prototype.build = function () {
        return this.customField;
    };
    return CustomFieldBuilder;
}());
export { CustomFieldBuilder };
//# sourceMappingURL=custom-field.builder.js.map